var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRollWheel = function SvgRollWheel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 98 98"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4h18.3c4.8 0 9 3.5 9.8 8.3L44 75.2l-4 .6L29.2 13a6 6 0 0 0-6-5H5V4ZM49 4h18.3c4.8 0 9 3.5 9.8 8.3L88 75.2l-4 .6L73.2 13a6 6 0 0 0-6-5H49V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 23.6 70 48.1l-4 .8-4.5-24.5 4-.8ZM49.5 23.6 54 48.1l-4 .8-4.5-24.5 4-.8ZM86.5 77a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM75 84.5a11.5 11.5 0 1 1 23 0 11.5 11.5 0 0 1-23 0ZM43.5 77a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM32 84.5a11.5 11.5 0 1 1 23 0 11.5 11.5 0 0 1-23 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 22H78v4H24.8L11 87.4 7 86.6 21.6 22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 59H16v-4h23v4ZM81 50H39v-4h42v4ZM18 88H1v-4h17v4Z"
  })));
};
export default SvgRollWheel;